import { NetworkManager, request, axiosMethod } from '@/api/http';
import type {
  GetInquiryTypesOutputDto,
  CreateInquiryOutputDto,
} from '@/shared/types/api/Api';

export interface WithdrawReasonItem {
  key: string;
  label: { ko: string; en: string; ja: string };
  emoji: string;
}

export interface GetWithdrawReasonsOutput {
  reasons: WithdrawReasonItem[];
}

interface ApiResponse<T> {
  status: number;
  message: string;
  data: T;
}

const instance = new NetworkManager('rizzling').getInstance();

/** 문의 유형 목록 조회 (인증 불필요) */
export async function getInquiryTypes(): Promise<GetInquiryTypesOutputDto> {
  const res = await request<ApiResponse<GetInquiryTypesOutputDto>>(
    instance,
    axiosMethod.GET,
    '/inquiry/types',
  );
  return res.data.data;
}

/** 회원탈퇴 사유 목록 조회 (인증 필수) */
export async function getWithdrawReasons(): Promise<GetWithdrawReasonsOutput> {
  const res = await request<ApiResponse<GetWithdrawReasonsOutput>>(
    instance,
    axiosMethod.GET,
    '/auth/withdraw/reasons',
  );
  return res.data.data;
}

/** 1:1 문의 등록 (form-data) */
export async function createInquiry(params: {
  email: string;
  type: string;
  content: string;
  images?: File[];
}): Promise<CreateInquiryOutputDto> {
  const formData = new FormData();
  formData.append('email', params.email);
  formData.append('type', params.type);
  formData.append('content', params.content);
  if (params.images) {
    params.images.forEach((file) => {
      formData.append('images', file);
    });
  }

  const res = await request<ApiResponse<CreateInquiryOutputDto>>(
    instance,
    axiosMethod.POST,
    '/inquiry',
    undefined,
    formData,
  );
  return res.data.data;
}
